// src/components/onboarding-banner.tsx
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { X, ArrowRight, RotateCcw } from 'lucide-react';
import { useOnboardingStorage } from '@/hooks/use-onboarding-storage';

export const OnboardingBanner = () => {
  const businessId = localStorage.getItem('businessId') || 'default';
  const { 
    completionCount,
    startOnboarding, 
    dismissPermanently 
  } = useOnboardingStorage(businessId);

  // Only show if completed exactly once (reminder mode)
  if (completionCount !== 1) return null;

  return (
    <Card className="border-amber-200 bg-gradient-to-r from-amber-50 to-orange-50 dark:from-amber-950/50 dark:to-orange-950/50">
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-amber-100 rounded-lg dark:bg-amber-900/50">
              <RotateCcw className="h-5 w-5 text-amber-600 dark:text-amber-400" />
            </div>
            <div>
              <div className="flex items-center gap-2 mb-1">
                <h3 className="font-semibold text-amber-900 dark:text-amber-100">
                  Take the Tour Again?
                </h3>
                <Badge variant="secondary" className="text-xs bg-amber-100 text-amber-700 dark:bg-amber-900 dark:text-amber-300">
                  Optional
                </Badge>
              </div>
              <p className="text-sm text-amber-700 dark:text-amber-300">
                Want a refresher? Take the guided tour again to explore features you might have missed.
              </p>
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            <Button
              onClick={startOnboarding}
              className="bg-amber-600 hover:bg-amber-700 text-white"
              size="sm"
            >
              Take Tour
              <ArrowRight className="h-4 w-4 ml-2" />
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={dismissPermanently}
              className="text-amber-600 hover:text-amber-700 h-8 w-8 p-0"
              title="Hide forever"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};